import {autoinject, PLATFORM,CompositionTransaction} from "aurelia-framework";
import {AureliaConfiguration} from "aurelia-configuration";
import {find} from 'lodash';

@autoinject()
export class CustomerService {

  auConf: AureliaConfiguration;
  customersList: any;
  customer: string;

  constructor(auConf: AureliaConfiguration) {
    this.auConf = auConf;
    this.customersList = this.auConf.get('custom-domains');
    this.customerInfo();
    this.customer = this.getCustomer();

    //Any other information or parameter that needs to be retrieved from DSSB for this customer
  }
  customerInfo(){
    let hostname = PLATFORM.location.hostname;
    this.customerInfo = find(this.customersList,{'url':hostname});
  }
  getCustomer () {
    let customer = '';
    if(this.customerInfo)
      customer=(this.customerInfo as any).customerId;
    return customer;
  }

  customHost () {
    return this.customer ? true : false;
  }

}
